import React from 'react';
import { formatArtifactDate } from '../../research/utils/researchArtifacts';
import '../../../pages/b2b/B2BAIInterviewPage.scss';

export default function ResearchPlanImportModal({
  isOpen,
  plans = [],
  loading = false,
  selectedPlanId,
  description,
  emptyMessage,
  onSelect,
  onCancel,
  onLoad,
}) {
  if (!isOpen) return null;
  const visibleItemCount = Math.min(Math.max(plans.length, 1), 3);
  const resolvedDescription = description || (
    <>
      Research에서 작성한 계획서를 선택해 주세요.
      <br />
      선택한 계획서의 목적과 맥락이 테스트 정보에 자동으로 입력됩니다.
    </>
  );
  const resolvedEmptyMessage = emptyMessage || (
    <>
      완료된 계획서가 없습니다.
      <br />
      Research에서 계획서를 먼저 만들어 주세요.
    </>
  );

  return (
    <div className="ai-interview-modal-backdrop" role="presentation">
      <section
        className="ai-interview-modal ai-interview-modal--artifact"
        role="dialog"
        aria-modal="true"
        aria-labelledby="research-plan-import-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="ai-interview-modal__header align-left">
          <h2 id="research-plan-import-title">리서치 계획서 불러오기</h2>
          <p>{resolvedDescription}</p>
        </header>
        <div className="ai-interview-modal__body ai-interview-artifact-select-body">
          <div className={`ai-interview-artifact-select-area is-${visibleItemCount}`}>
          {loading ? (
            <p className="ai-interview-dialog-copy">목록을 불러오고 있습니다.</p>
          ) : plans.length === 0 ? (
            <p className="ai-interview-dialog-copy">{resolvedEmptyMessage}</p>
          ) : (
            <div className="ai-interview-select-list">
              {plans.map((plan) => {
                const selected = String(selectedPlanId) === String(plan.id);
                return (
                  <button
                    key={plan.id}
                    type="button"
                    className={`ai-interview-select-option ${selected ? 'selected' : ''}`}
                    onClick={() => onSelect(plan.id)}
                  >
                    <span className={`ai-interview-selection-dot ${selected ? 'selected' : ''}`} aria-hidden="true" />
                    <span>
                      <strong>{plan.title}</strong>
                      <em>
                        {plan.projectName ? `${plan.projectName} · ` : ''}
                        생성일: {formatArtifactDate(plan.createdAt) || '-'}
                      </em>
                    </span>
                  </button>
                );
              })}
            </div>
          )}
          </div>
        </div>
        <footer className="ai-interview-modal__footer">
          <button type="button" className="ai-interview-button secondary" onClick={onCancel}>취소하기</button>
          <button
            type="button"
            className="ai-interview-button primary"
            onClick={onLoad}
            disabled={loading || !selectedPlanId || plans.length === 0}
          >
            불러오기
          </button>
        </footer>
      </section>
    </div>
  );
}
